import React, { useMemo } from 'react';

export type ProfileAvatarCircleProps = {
  fullname?: string;
  size?: number;
};

const PALETTE = [
  '#FF8E8E', //1
  '#E994AB',
  '#67C7E2',
  '#A5D3CA',
  '#99C7FF', //5
  '#A8E4FF',
  '#75ECFD',
  '#92FEF9',
  '#7DFDD7',
  '#8BFEA8', //10
  '#FFACEC',
  '#EFA9FE',
  '#C4ABFE',
  '#EEEEA2' //14
];

const hexEncode = (input: string): string => {
  let i = 0;
  let h = '';
  while (i < input.length) {
    h += input.charCodeAt(i++).toString(16);
  }
  return h;
};

const lookupColour = (name: string): string => {
  const hex = hexEncode(name);
  const hexint = parseInt(hex, 16);
  const paletteIndex = getColorId(hexint);
  return PALETTE[paletteIndex];
};

const getColorId = (hexint: number) => {
  const numColors = PALETTE.length;
  let ranged = hexint;
  while (ranged > numColors) {
    ranged = ranged / numColors;
  }
  return Math.floor(ranged);
};

export const ProfileAvatarCircle = (props: ProfileAvatarCircleProps) => {
  const { fullname, size = 100 } = props;

  const firstLetter = useMemo(() => {
    return fullname ? fullname.charAt(0) : '?';
  }, [fullname]);

  const backgroundColor = useMemo(() => {
    return fullname ? lookupColour(fullname) : undefined;
  }, [fullname]);

  return (
    <div
      className={`profile-avatar-circle circle w-${size} h-${size} white-text`}
      title={fullname}
      style={{ backgroundColor }}
    >
      {size >= 80 && (
        <h1 className="center-align mt-25 fs-50">{firstLetter}</h1>
      )}
      {size < 80 && size >= 40 && (
        <h3 className="center-align m-0 fs-20 lh-40">{firstLetter}</h3>
      )}
      {size < 40 && (
        <h4 className={`center-align mt-5 lh-${size}`}>{firstLetter}</h4>
      )}
    </div>
  );
};
